import _classCallCheck from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { IdentifierRole } from "../parser/tokenizer";
import { TokenType as tt } from "../parser/tokenizer/types";
import Transformer from "./Transformer";
/**
 * Implementation of babel-plugin-transform-react-display-name, which adds a
 * display name to usages of React.createClass and createReactClass.
 */

var ReactDisplayNameTransformer = /*#__PURE__*/function (_Transformer) {
  _inherits(ReactDisplayNameTransformer, _Transformer);

  var _super = _createSuper(ReactDisplayNameTransformer);

  function ReactDisplayNameTransformer(rootTransformer, tokens, importProcessor, options) {
    var _this;

    _classCallCheck(this, ReactDisplayNameTransformer);

    _this = _super.call(this);
    _this.rootTransformer = rootTransformer;
    _this.tokens = tokens;
    _this.importProcessor = importProcessor;
    _this.options = options;
    ;
    return _this;
  }

  _createClass(ReactDisplayNameTransformer, [{
    key: "process",
    value: function process() {
      var startIndex = this.tokens.currentIndex();

      if (this.tokens.identifierName() === "createReactClass") {
        var newName = this.importProcessor && this.importProcessor.getIdentifierReplacement("createReactClass");

        if (newName) {
          this.tokens.replaceToken("(0, ".concat(newName, ")"));
        } else {
          this.tokens.copyToken();
        }

        this.tryProcessCreateClassCall(startIndex);
        return true;
      }

      if (this.tokens.matches3(tt.name, tt.dot, tt.name) && this.tokens.identifierName() === "React" && this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 2) === "createClass") {
        var _newName = this.importProcessor ? this.importProcessor.getIdentifierReplacement("React") || "React" : "React";

        if (_newName) {
          this.tokens.replaceToken(_newName);
          this.tokens.copyToken();
          this.tokens.copyToken();
        } else {
          this.tokens.copyToken();
          this.tokens.copyToken();
          this.tokens.copyToken();
        }

        this.tryProcessCreateClassCall(startIndex);
        return true;
      }

      return false;
    }
    /**
     * This is called with the token position at the open-paren.
     */

  }, {
    key: "tryProcessCreateClassCall",
    value: function tryProcessCreateClassCall(startIndex) {
      var displayName = this.findDisplayName(startIndex);

      if (!displayName) {
        return;
      }

      if (this.classNeedsDisplayName()) {
        this.tokens.copyExpectedToken(tt.parenL);
        this.tokens.copyExpectedToken(tt.braceL);
        this.tokens.appendCode("displayName: '".concat(displayName, "',"));
        this.rootTransformer.processBalancedCode();
        this.tokens.copyExpectedToken(tt.braceR);
        this.tokens.copyExpectedToken(tt.parenR);
      }
    }
  }, {
    key: "findDisplayName",
    value: function findDisplayName(startIndex) {
      if (startIndex < 2) {
        return null;
      }

      if (this.tokens.matches2AtIndex(startIndex - 2, tt.name, tt.eq)) {
        // This is an assignment (or declaration) and the LHS is either an identifier or a member
        // expression ending in an identifier, so use that identifier name.
        return this.tokens.identifierNameAtIndex(startIndex - 2);
      }

      if (startIndex >= 2 && this.tokens.tokens[startIndex - 2].identifierRole === IdentifierRole.ObjectKey) {
        // This is an object literal value.
        return this.tokens.identifierNameAtIndex(startIndex - 2);
      }

      if (this.tokens.matches2AtIndex(startIndex - 2, tt._export, tt._default)) {
        return this.getDisplayNameFromFilename();
      }

      return null;
    }
  }, {
    key: "getDisplayNameFromFilename",
    value: function getDisplayNameFromFilename() {
      var filePath = this.options.filePath || "unknown";
      var pathSegments = filePath.split("/");
      var filename = pathSegments[pathSegments.length - 1];
      var dotIndex = filename.lastIndexOf(".");
      var baseFilename = dotIndex === -1 ? filename : filename.slice(0, dotIndex);

      if (baseFilename === "index" && pathSegments[pathSegments.length - 2]) {
        return pathSegments[pathSegments.length - 2];
      } else {
        return baseFilename;
      }
    }
    /**
     * We only want to add a display name when this is a function call containing
     * one argument, which is an object literal without `displayName` as an
     * existing key.
     */

  }, {
    key: "classNeedsDisplayName",
    value: function classNeedsDisplayName() {
      var index = this.tokens.currentIndex();

      if (!this.tokens.matches2(tt.parenL, tt.braceL)) {
        return false;
      } // The block starts on the {, and we expect any displayName key to be in
      // that context. We need to ignore other other contexts to avoid matching
      // nested displayName keys.


      var objectStartIndex = index + 1;
      var objectContextId = this.tokens.tokens[objectStartIndex].contextId;

      if (objectContextId == null) {
        throw new Error("Expected non-null context ID on object open-brace.");
      }

      for (; index < this.tokens.tokens.length; index++) {
        var token = this.tokens.tokens[index];

        if (token.type === tt.braceR && token.contextId === objectContextId) {
          index++;
          break;
        }

        if (this.tokens.identifierNameAtIndex(index) === "displayName" && this.tokens.tokens[index].identifierRole === IdentifierRole.ObjectKey && token.contextId === objectContextId) {
          // We found a displayName key, so bail out.
          return false;
        }
      }

      if (index === this.tokens.tokens.length) {
        throw new Error("Unexpected end of input when processing React class.");
      } // If we got this far, we know we have createClass with an object with no
      // display name, so we want to proceed as long as that was the only argument.


      return this.tokens.matches1AtIndex(index, tt.parenR) || this.tokens.matches2AtIndex(index, tt.comma, tt.parenR);
    }
  }]);

  return ReactDisplayNameTransformer;
}(Transformer);

export { ReactDisplayNameTransformer as default };